const FA = [
	{
		side: "Home / Round 3",
		team: "Aston Villa",
		result: "1-0",
		possession: "54 %",
		shots: 19,
		onTarget: 10,
		passes: 422,
		passesCompleted: 333,
		tackles: 9,
		aerial: 13,
	},
	{
		side: "Home / Round 4",
		team: "Middlesbrough",
		result: "1-1 / Pens: 7-8",
		possession: "71 %",
		shots: 30,
		onTarget: 9,
		passes: 913,
		passesCompleted: 773,
		tackles: 11,
		aerial: 40,
	},
];

export default FA;
